var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoldBars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2536_549",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2536_549",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACAklEQVR4nO3bu0oDQRSA4a2ClyIzaUQQ7Lew2Tkhna8gXp4nzDQKGn0KifG5TKFoE7VWVpNCtJHM7MyB/4NtF85hZ4v92aoCAAAAAAAAAJSkrsY9Mf7a2fAiNnz853LWPzvjr9p75J6jeGLDzX8X/GvhJkxyz1G00d5k0xm/WH/RfnG4P97IPU+x3MCfrLvk1TXsh6Pc8xRLTLiLtWhn/W3ueYrU7I63xITXWItu79W+inLPVZxmEE6jLXn1VPfDce65iuOMn8VetBg/zT1Xga8N/xZ/0eH9YOdyO/d8xRgO/Fn0JS+v9pWUe75iOBPuUy26fSXlnq8YYv1TskXb8Jh7vmKICfOET/RD7vmK4Yy/SPhEn+eerxh1Ne59LTvmk23CvL0nX/IAAABUxdaamNtNbBVibvrYOiLmfmsLR8rY6oi5y2Nt/DRlbBVibvrY2hBz4x9r+SO2EnMTHGv5I7YSc1Mca/szthJzEx5rWV7tvYm5KY+1Xb6njZ8RczuKrULM7Sa2CjG3m9jqiLndxNaamAsAABCL9thaa4m52mOraIi52mPrSEvM1R5bnZaYqz22ioaYqz22NlpirvbY2mj5M1d7bHUa/szVHlsbLX/mao+tQy1/5mqPrU7Ln7naY6toibnaY6toibnaY6vTEnO1x9aamAsAAAAAAAAAAFDp8wnK40NyKXQHBwAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldBars);
export default __webpack_public_path__ + "static/media/Gold Bars.d19707cf2453b8882d75333036132d89.svg";
export { ForwardRef as ReactComponent };